/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Req_TitleInputs */

const en_fc_online_req_title = /** @type {(inputs: Fc_Online_Req_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser requirements`)
};

/**
* | output |
* | --- |
* | "Browser requirements" |
*
* @param {Fc_Online_Req_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_req_title = /** @type {((inputs?: Fc_Online_Req_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Req_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_req_title(inputs)
});
export { fc_online_req_title as "fc.online.req.title" }